import { Row } from 'antd';
import styled from 'styled-components';

export const Container = styled(Row)`
  margin: 12px;
`;
